import { ApiProperty } from '@nestjs/swagger';
import { MaterialDeliverySheetInterface } from '../interfaces/material-delivery-sheet.interface';
import { Exclude, Expose } from 'class-transformer';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { BuilderInterface } from '../../builder/interfaces/builder.interface';
import { JobInterface } from '../../job/interfaces/job.interface';
import { SubdivisionInterface } from '../../subdivision/interfaces/subdivision.interface';
import { SupplierInterface } from '../../supplier/interfaces/supplier.interface';
import { BoardPurchasePartialDeliveryDto } from '../../board-purchase-partial-delivery/dto/board-purchase-partial-delivery.dto';
import { DeliveryDateSourceEnum } from '../enums/delivery-date-source.enum';

@Exclude()
export class MaterialDeliverySheetDto
  extends CommonEntityDto
  implements MaterialDeliverySheetInterface
{
  @ApiProperty({
    type: () => [BoardPurchasePartialDeliveryDto],
    title: 'BoardPurchasePartialDeliveryDto',
  })
  @Expose()
  boardPurchasePartialDeliveries!: BoardPurchasePartialDeliveryDto[];

  @ApiProperty({
    title: 'Job ID (synonym for React Admin only)',
  })
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'Job Lot',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Job Block',
  })
  @Expose()
  jobBlock!: string;

  @ApiProperty({
    title: 'Builder Id',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'Builder Name',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    title: 'SubdivisionId',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    title: 'Subdivision Name',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    title: 'Supervisor Id',
  })
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({
    title: 'Order Number',
  })
  @Expose()
  orderNumber!: string;

  @ApiProperty({
    title: 'Date Delivery',
  })
  @Expose()
  dateDelivery?: Date | null | undefined;

  @ApiProperty({
    title: 'Date Promised',
  })
  @Expose()
  datePromised?: Date | null | undefined;

  @ApiProperty({
    title: 'Date Expected',
  })
  @Expose()
  dateExpected?: Date | undefined;

  @ApiProperty({
    title: 'Original Date Expected',
  })
  @Expose()
  originalDateExpected?: Date | undefined;

  @ApiProperty({
    title: 'Board Purchase creation date',
  })
  @Expose()
  orderDate?: Date | undefined;

  @ApiProperty({
    title: 'PO Creating User ID',
    nullable: true,
  })
  @Expose()
  createdByUserId?: string | null;

  @ApiProperty({
    title: 'PO Creating User Name',
    nullable: true,
  })
  @Expose()
  createdByName?: string | null;

  @ApiProperty({
    title: 'Full Address',
  })
  @Expose()
  fullAddress!: string;

  @ApiProperty({
    title: 'No Promissed Date',
  })
  @Expose()
  noPromissedDate!: boolean;

  @ApiProperty({
    title: 'Is High Priority',
  })
  @Expose()
  isHighPriority!: boolean;

  @ApiProperty({
    title: 'No Delivery Date',
  })
  @Expose()
  noDeliveryDate!: boolean;

  @ApiProperty({
    title: 'Late',
  })
  @Expose()
  late!: boolean;

  @ApiProperty({
    title: 'approved?',
  })
  @Expose()
  approved!: boolean;

  @ApiProperty({
    title: 'Created In The Last 180 Days?',
  })
  @Expose()
  createdInTheLast180Days!: boolean;

  @ApiProperty({
    title: 'Approved In The Last 5 Days?',
  })
  @Expose()
  approvedInTheLast5Days!: boolean;

  @ApiProperty({
    title: 'Supplier id',
  })
  @Expose()
  supplierId!: string;

  @ApiProperty({
    title: 'Supplier Name',
  })
  @Expose()
  supplierName!: string;

  @ApiProperty({
    title: 'Delivery Date Source',
    nullable: true,
    type: 'enum',
    enum: DeliveryDateSourceEnum,
  })
  @Expose()
  deliveryDateSource!: DeliveryDateSourceEnum | null;

  @ApiProperty({
    title: 'Job',
  })
  @Expose()
  job?: JobInterface | undefined;

  @ApiProperty({
    title: 'Subdivision',
  })
  @Expose()
  subdivision?: SubdivisionInterface | undefined;

  @ApiProperty({
    title: 'Builder',
  })
  @Expose()
  builder?: BuilderInterface | undefined;

  @ApiProperty({
    title: 'Supplier',
  })
  @Expose()
  supplier?: SupplierInterface | undefined;
}
